module.exports = __webpack_public_path__ + "img/tongfangrenshou.d18afef9.png";